import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { PageHeroComponent } from '../../../shared/page-layout/page-hero.component';
import { PageShellComponent } from '../../../shared/page-layout/page-shell.component';

@Component({
    selector: 'app-mobilization-timesheet-grid',
    standalone: true,
    templateUrl: './mobilization-timesheet-grid.component.html',
    styleUrls: ['./mobilization-timesheet-grid.component.css'],
    imports: [
        CommonModule,
        RouterModule,
        BreadcrumbModule,
        ButtonModule,
        PageShellComponent,
        PageHeroComponent,
        PageDataPanelComponent
    ]
})
export class MobilizationTimesheetGridComponent implements OnInit {
    breadcrumbItems: MenuItem[] = [];
    homeBreadcrumb: MenuItem = { icon: 'pi pi-home', routerLink: '/' };

    ngOnInit(): void {
        this.breadcrumbItems = [{ label: 'Fleet', routerLink: '/fleet' }, { label: 'Mobilization', routerLink: '/fleet/mobilization' }, { label: 'Timesheets' }];
    }
}
